import React, {
  useState,
  useCallback,
  useMemo,
  useEffect,
  createRef,
} from "react";
import IconOptionSelector from "./IconOptionSelector";
import DressPreviewCanvas from "./DressPreviewCanvas";
import InfoPane from "./InfoPane";
import { fetchDressImage } from "../api/dressApi";
// The filterOptions function is assumed to be in the same file as the map.
import { compatibilityMap, filterOptions } from "./compatibilityMap";
import { useAuth } from "../contexts/AuthProvider";
import DesignSpecifications from "./DressSpecification";
import { Popover } from "@headlessui/react";
import MadeToMeasureModal from "./MadeToMeasureModal";

const SHOPIFY_STORE_URL = "velurabliss.com.au";
const SHOPIFY_VARIANT_ID = "45595616739503"; // This is the ID you found

const CATEGORIES_CONFIG = {
  SHAPE: {
    id: "SHAPE",
    title: "Shape & Fit",
    fields: ["bodice", "neckline", "sleeve", "backstyle", "skirt", "length"],
    next: "MATERIALS",
    icon: "📐",
  },
  MATERIALS: {
    id: "MATERIALS",
    title: "Fabric & Color",
    fields: ["fabric", "color"],
    next: "SCENE",
    icon: "🎨",
  },
  SCENE: {
    id: "SCENE",
    title: "Scene & Style",
    fields: ["ambience"],
    next: null,
    icon: "🖼️",
  },
};
const CATEGORY_ORDER = ["SHAPE", "MATERIALS", "SCENE"];

function CustomizationPanel() {
  const [bodice, setBodice] = useState("");
  const [skirt, setSkirt] = useState("");
  const [neckline, setNeckline] = useState("");
  const [sleeve, setSleeve] = useState("");
  const [length, setLength] = useState("");
  const [backstyle, setBackstyle] = useState("");
  const [color, setColor] = useState("");
  const [fabric, setFabric] = useState("");
  const [ambience, setAmbience] = useState("");

  const [generatedImage, setGeneratedImage] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [dressName, setDressName] = useState(null);
  const [previewedValues, setPreviewedValues] = useState({
    bodice: null,
    neckline: null,
    sleeve: null,
    skirt: null,
    length: null,
    backstyle: null,
    fabric: null,
    color: null,
    ambience: null,
  });

  const [isSizingModalOpen, setIsSizingModalOpen] = useState(false);
  const [activeCategoryId, setActiveCategoryId] = useState(CATEGORY_ORDER[0]);
  const [hoveredOptionInfo, setHoveredOptionInfo] = useState(null);
  const [completedCategories, setCompletedCategories] = useState({});

  const [measurements, setMeasurements] = useState(null);

  const { isAuthenticated, authError, isAuthLoading, reInitiateSession } =
    useAuth();

  const optionGroupRefs = useMemo(() => {
    const refs = {};
    CATEGORY_ORDER.forEach((catId) => {
      CATEGORIES_CONFIG[catId].fields.forEach((field) => {
        refs[field] = createRef();
      });
    });
    return refs;
  }, []);

  const selectedValues = useMemo(
    () => ({
      bodice,
      skirt,
      neckline,
      sleeve,
      backstyle,
      length,
      color,
      fabric,
      ambience,
    }),
    [
      bodice,
      skirt,
      neckline,
      sleeve,
      backstyle,
      length,
      color,
      fabric,
      ambience,
    ]
  );

  //// In CustomizationPanel.js

  //const handleAddToCart = () => {
  //  // Make sure all required values are selected before proceeding
  //  if (!canGenerate) {
  //    alert("Please complete your dress design first!");
  //    return;
  //  }

  //  // --- Step 1: Build the Shopify Cart Permalink URL ---
  //  let checkoutUrl = `https://${SHOPIFY_STORE_URL}/cart/add?id=${SHOPIFY_VARIANT_ID}&quantity=1`;

  //  const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

  //  // Add each selected value as a line item property
  //  for (const [key, value] of Object.entries(selectedValues)) {
  //    if (value) {
  //      const propertyKey = capitalize(key);
  //      // Format the value for display (e.g., 'strappy-v-neck' becomes 'Strappy V Neck')
  //      const propertyValue = value.split('-').map(capitalize).join(' ');
  //      // Add the encoded property to the URL
  //      checkoutUrl += `&properties[${encodeURIComponent(propertyKey)}]=${encodeURIComponent(propertyValue)}`;
  //    }
  //  }

  //  // VVVV THIS IS THE LINE TO CHECK AND CORRECT VVVV
  //  // It must use '_DesignPreview' as the property name
  //  if (generatedImage) {
  //    checkoutUrl += `&properties[_DesignPreview]=${encodeURIComponent(generatedImage)}`;
  //  }

  //  // --- Step 2: Redirect the User's Browser Directly to the URL ---
  //  //console.log("Redirecting to Shopify:", checkoutUrl);
  //  //window.location.href = checkoutUrl;
  //};

  // In CustomizationPanel.js

  // NEW function #1: This will be called when the user confirms their measurements in the modal.
  // Its only job is to save the measurements to state and close the modal.
  const handleMeasurementsConfirm = (confirmedMeasurements) => {
    console.log({ confirmedMeasurements });
    setMeasurements(confirmedMeasurements);
    setIsSizingModalOpen(false);
  };

  // NEW function #2: This will be called by the final "Add to Cart" button.
  // It contains the logic to build the Shopify URL and redirect the user.
  // In CustomizationPanel.js

  //const handleFinalAddToCart = async () => {
  //  // --- Step 1: Set loading state to TRUE ---
  //  setLoading(true);

  //  const finalSelectedValues = {
  //    bodice, skirt, neckline, sleeve, backstyle, length, color, fabric, ambience,
  //    ...measurements
  //  };

  //  let checkoutUrl = `https://${SHOPIFY_STORE_URL}/cart/add?id=${SHOPIFY_VARIANT_ID}&quantity=1`;
  //  const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

  //  for (const [key, value] of Object.entries(finalSelectedValues)) {
  //    if (value) {
  //      const propertyKey = key.replace(/([A-Z])/g, ' $1').split(' ').map(capitalize).join(' ');
  //      const propertyValue = typeof value === 'string' ? value.split('-').map(capitalize).join(' ') : `${value} cm`;
  //      checkoutUrl += `&properties[${encodeURIComponent(propertyKey)}]=${encodeURIComponent(propertyValue)}`;
  //    }
  //  }

  //  if (generatedImage) {
  //    checkoutUrl += `&properties[_DesignPreview]=${encodeURIComponent(generatedImage)}`;
  //  }

  //  try {
  //    const response = await fetch('/api/addToCart', {
  //      method: 'POST',
  //      headers: { 'Content-Type': 'application/json' },
  //      body: JSON.stringify({ items: [{ id: SHOPIFY_VARIANT_ID, quantity: 1, properties: finalSelectedValues.properties }] })
  //    });

  //    if (!response.ok) {
  //      const errorData = await response.json();
  //      alert(`Error: ${errorData.description || 'Could not add item to cart.'}`);
  //      setLoading(false); // <-- Set loading to FALSE on error
  //      return;
  //    }

  //    window.location.href = `https://${SHOPIFY_STORE_URL}/cart`;

  //  } catch (error) {
  //    alert("Could not contact the server. Please check your connection and try again.");
  //    setLoading(false); // <-- Set loading to FALSE on error
  //  }
  //};

  const handleFinalAddToCart = () => {
    // Make sure all required values are selected before proceeding
    if (!canGenerate) {
      alert("Please complete your dress design first!");
      return;
    }
    let checkoutUrl = `https://${SHOPIFY_STORE_URL}/cart/add?id=${SHOPIFY_VARIANT_ID}&quantity=1`;
    const finalSelectedValues = {
      dressName,
      bodice,
      skirt,
      neckline,
      sleeve,
      backstyle,
      length,
      color,
      fabric,
      ambience,
      ...measurements,
    };

    const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

    for (const [key, value] of Object.entries(finalSelectedValues)) {
      if (value) {
        const propertyKey = key
          .replace(/([A-Z])/g, " $1")
          .split(" ")
          .map(capitalize)
          .join(" ");
        const propertyValue =
          typeof value === "string"
            ? value.split("-").map(capitalize).join(" ")
            : `${value} cm`;
        checkoutUrl += `&properties[${encodeURIComponent(
          propertyKey
        )}]=${encodeURIComponent(propertyValue)}`;
      }
    }

    // VVVV THIS IS THE LINE TO CHECK AND CORRECT VVVV
    // It must use '_DesignPreview' as the property name
    if (generatedImage) {
      checkoutUrl += `&properties[_DesignPreview]=${encodeURIComponent(
        generatedImage
      )}`;
    }

    // --- Step 2: Redirect the User's Browser Directly to the URL ---
    console.log("Redirecting to Shopify:", checkoutUrl);
    window.location.href = checkoutUrl;
  };
  // In CustomizationPanel.js

  const dynamicDressName = useMemo(() => {
    // This helper function builds the impressive name
    const generateImpressiveName = (specs) => {
      const { bodice, skirt, neckline, length } = specs;

      // If not enough info is selected, return a default name
      if (!bodice || !skirt || !neckline) {
        return "Custom Designed Dress";
      }

      // --- Naming Logic ---
      let primaryAdjective = "";
      let coreName = "Dress";

      // 1. Determine the core name based on the silhouette (skirt + length)
      // This gives us the foundational name of the garment.
      if (skirt === "flared" && length === "maxi") {
        coreName = "Ball Gown";
      } else if (skirt === "trumpet") {
        coreName = "Mermaid Gown";
      } else if (skirt === "a-line-straight") {
        coreName = "A-Line Dress";
      } else if (bodice === "sheath") {
        coreName = "Sheath Dress";
      }

      // 2. Determine a primary adjective based on a key feature
      // This gives the name its unique personality.
      if (neckline === "sweetheart") {
        primaryAdjective = "Romantic";
      } else if (bodice === "corset") {
        primaryAdjective = "Enchanting";
      } else if (bodice === "empire") {
        primaryAdjective = "Gracious Empire";
      } else if (neckline === "boat" || neckline === "cowl") {
        primaryAdjective = "Elegant";
      } else if (bodice === "draped") {
        primaryAdjective = "Grecian Draped";
      }

      // 3. Combine the parts into a final, impressive name
      if (primaryAdjective) {
        return `${primaryAdjective} ${coreName}`;
      }

      // 4. If no special adjective was found, return the core name
      return coreName;
    };

    const values = generateImpressiveName(selectedValues);
    setDressName(values);
    // Call the name builder function with the latest selections
    return generateImpressiveName(selectedValues);
  }, [selectedValues]); // This now depends on all selected values

  const { bodiceOptions, skirtOptions, necklineOptions, genericOptions } =
    useMemo(() => {
      return {
        bodiceOptions: [
          {
            label: "Sheath",
            value: "sheath",
            icon: "/icons/dress-type/sheath_bodice_type.png",
            description:
              "A sleek, form-fitting bodice that contours to the body.",
          },
          {
            label: "Blouson",
            value: "blouson",
            icon: "/icons/dress-type/top_blouson_bodice_type.png",
            description:
              "A draped, billowy bodice that has a gathered or cinched waistline, creating a soft, full look on top.",
          },
          {
            label: "Flared",
            value: "flared",
            icon: "/icons/dress-type/flared_bodice_type.png",
            description:
              "A bodice that gradually widens from the bust or waist downwards, creating a gentle flare.",
          },
          {
            label: "Wrapped",
            value: "wrapped",
            icon: "/icons/dress-type/top_wrapped_bodice_type.png",
            description:
              "Features a wrap-around style where one side crosses over the other, often creating a V-neckline and accentuating the waist.",
          },
          {
            label: "Empire",
            value: "empire",
            icon: "/icons/dress-type/empire_bodice_type.png",
            description:
              "Fitted just below the bust line, with the rest of the bodice flowing loosely downwards.",
          },
          {
            label: "Corset",
            value: "corset",
            icon: "/icons/dress-type/corset_bodice_type.png",
            description:
              "A structured, often boned, figure-hugging bodice that cinches the waist and shapes the torso.",
          },
          {
            label: "Peplum",
            value: "peplum",
            icon: "/icons/dress-type/peplum_bodice_type.png",
            description:
              "A bodice with a short, flared strip of fabric attached at the waist, creating a playful ruffle.",
          },
          {
            label: "Draped",
            value: "draped",
            icon: "/icons/dress-type/draped_bodice_type.png",
            description:
              "Artfully gathered and draped fabric across the bodice for a soft, flowing, and often Grecian look.",
          },
          {
            label: "Asymmetrical",
            value: "asymmetrical",
            icon: "/icons/dress-type/asymmetrical_bodice_type.png",
            description:
              "Features an uneven design, such as a one-shoulder style or an off-center neckline or draping.",
          },
        ],
        skirtOptions: [
          {
            label: "A-Line Straight",
            value: "a-line-straight",
            icon: "/icons/skirt-type/a_line.png",
            description:
              "Gently flares from the hips, forming an 'A' shape. A classic and versatile choice.",
          },
          {
            label: "High-Low",
            value: "high-low",
            icon: "/icons/skirt-type/bottom_high.png",
            description:
              "Features an asymmetrical hemline that is shorter at the front and longer at the back.",
          },
          {
            label: "Flared",
            value: "flared",
            icon: "/icons/skirt-type/flared_skirt_type.png",
            description:
              "Widens significantly towards the hem, creating a full and flowing effect. Can range from subtle to dramatic.",
          },
          {
            label: "Tiered",
            value: "tiered",
            icon: "/icons/skirt-type/tiered_skirt_type.png",
            description:
              "A layered tiered dkirt style, where multiple layers are put.",
          },
          {
            label: "Pencil",
            value: "pencil",
            icon: "/icons/skirt-type/pencil_skirt_type.png",
            description:
              "A slim, straight-cut skirt that hugs the body from waist to hem, typically knee-length.",
          },
          {
            label: "Circle",
            value: "circle",
            icon: "/icons/skirt-type/circle_skirt_type.png",
            description:
              "A very full skirt that forms a perfect circle when laid flat, known for its beautiful drape and movement.",
          },
          {
            label: "Trumpet",
            value: "trumpet",
            icon: "/icons/skirt-type/trumpet_skirt_type.png",
            description:
              "Fitted through the hips and thighs, then flares out from mid-thigh or the knee, resembling a trumpet bell. Also known as a mermaid skirt when the flare is lower.",
          },
        ],
        necklineOptions: [
          {
            label: "V-Neck",
            value: "v-shaped",
            icon: "/icons/neck-style/v_neckline.png",
            description:
              "A classic V-shaped neckline, can be demure or daring depending on depth.",
          },
          {
            label: "Boat Neck",
            value: "boat",
            icon: "/icons/neck-style/boat_neckline.png",
            description:
              "A wide neckline that runs horizontally, front and back, almost to the shoulder points.",
          },
          {
            label: "Halter Neck",
            value: "halter",
            icon: "/icons/neck-style/halter_neckline.png",
            description:
              "Features straps that wrap around the back of the neck, leaving the shoulders and upper back bare.",
          },
          {
            label: "Round Neck",
            value: "round",
            icon: "/icons/neck-style/round_neckline.png",
            description:
              "A simple, classic rounded neckline. Also known as a crew neck if high.",
          },
          {
            label: "Strappy V-Neck",
            value: "strappy-v-neck",
            icon: "/icons/neck-style/strappy_v_neckline.png",
            description:
              "A V-neckline accented with delicate straps, adding a modern touch.",
          },
          {
            label: "Sweetheart Neck",
            value: "sweetheart",
            icon: "/icons/neck-style/sweetheart_neckline.png",
            description:
              "Shaped like the top curves of a heart, romantic and flattering.",
          },
          {
            label: "Square Neck",
            value: "square",
            icon: "/icons/neck-style/square_neckline.png",
            description:
              "A neckline with straight, angular lines forming a square or rectangle shape.",
          },
          {
            label: "U-Shaped Neck",
            value: "u-shaped",
            icon: "/icons/neck-style/scoop_neckline.png",
            description: "A deep, curved U-shaped neckline.",
          },
          {
            label: "Surplice Neck",
            value: "surplice",
            icon: "/icons/neck-style/surplice_neckline.png",
            description:
              "Formed by one side of the fabric diagonally overlapping the other, creating a V-shape.",
          },
          {
            label: "One Shoulder",
            value: "one-shoulder-neck",
            icon: "/icons/neck-style/one_shoulder_neckline.png",
            description:
              "An asymmetrical neckline that features a single shoulder strap or sleeve.",
          },
          {
            label: "Cowl Neck",
            value: "cowl",
            icon: "/icons/neck-style/cowl_neckline.png",
            description:
              "Features softly draped folds of fabric at the neckline, creating a graceful effect.",
          },
          {
            label: "Jewel Neck",
            value: "jewel",
            icon: "/icons/neck-style/jewel_neckline.png",
            description:
              "A high, rounded neckline that sits at the base of the throat, often plain like a setting for a jewel.",
          },
          {
            label: "Illusion Neck",
            value: "illusion",
            icon: "/icons/neck-style/illusion_neckline.png",
            description:
              "Features a transparent panel of sheer fabric or lace from the bust to the collarbone, giving the illusion of a strapless dress with coverage.",
          },
          {
            label: "Strapless",
            value: "strapless",
            icon: "/icons/neck-style/strapless_neckline.png",
            description:
              "A neckline that sits above the bust with no straps, leaving the shoulders and collarbone bare.",
          },
          {
            label: "Asymmetrical Neck",
            value: "asymmetrical-neck",
            icon: "/icons/dress-type/asymmetrical_bodice_type.png",
            description:
              "An off-center neckline that creates a non-symmetrical look.",
          },
        ],
        genericOptions: {
          sleeve: [
            {
              label: "Sleeveless",
              value: "sleeveless",
              icon: "/icons/sleeves-type/without_sleeves.png",
              description:
                "No sleeves, for a look that highlights the arms and shoulders.",
            },
            {
              label: "Cap Sleeve",
              value: "cap",
              icon: "/icons/sleeves-type/cap_sleeves.png",
              description:
                "A very short sleeve that sits on the shoulder, just covering the very top of the arm.",
            },
            {
              label: "Short Sleeve",
              value: "short",
              icon: "/icons/sleeves-type/short_sleeves.png",
              description:
                "A sleeve ending somewhere between the shoulder and the elbow.",
            },
            {
              label: "Bell Sleeve",
              value: "bell",
              icon: "/icons/sleeves-type/bell_sleeves.png",
              description:
                "Fitted at the shoulder and arm, then dramatically flares out towards the wrist, like a bell.",
            },
            {
              label: "Bishop Sleeve",
              value: "bishop",
              icon: "/icons/sleeves-type/bishop_sleeves.png",
              description:
                "A long sleeve that is full from the shoulder, then gathered into a cuff at the wrist.",
            },
            {
              label: "Long Sleeve",
              value: "long",
              icon: "/icons/sleeves-type/long_sleeves.png",
              description:
                "A sleeve that extends to the wrist, offering full arm coverage.",
            },
          ],
          length: [
            {
              label: "Mini",
              value: "mini",
              icon: "/icons/dress-length/mini_dress_length.png",
              description:
                "A very short dress, typically ending mid-thigh or higher. Playful and bold.",
            },
            {
              label: "Midi",
              value: "midi",
              icon: "/icons/dress-length/midi_dress_length.png",
              description:
                "A versatile length falling anywhere from below the knee to mid-calf.",
            },
            {
              label: "Maxi",
              value: "maxi",
              icon: "/icons/dress-length/maxi_dress_length.png",
              description:
                "A long dress, typically extending to the ankle or floor. Elegant and often formal.",
            },
          ],
          backstyle: [
            {
              label: "Zipper",
              value: "zipper",
              icon: "/icons/back-style/zipper_back.png",
              description:
                "Features a standard zipper closure, often concealed for a clean look.",
            },
            {
              label: "Button-Up",
              value: "button-up",
              icon: "/icons/back-style/button_up_back.png",
              description:
                "A classic closure with a row of buttons down the back, can be decorative or functional.",
            },
            {
              label: "Lace-Up",
              value: "lace-up",
              icon: "/icons/back-style/lace_up_back.png",
              description:
                "A corset-style lacing detail at the back, allowing for an adjustable fit.",
            },
            {
              label: "Open",
              value: "open",
              icon: "/icons/back-style/open_back.png",
              description:
                "A design that exposes a significant portion of the back, can be dramatic or subtly alluring.",
            },
            {
              label: "Cross Back",
              value: "cross-back",
              icon: "/icons/back-style/cross_back.png",
              description:
                "Features straps that cross over each other at the back, adding a stylish detail.",
            },
            {
              label: "V-Back",
              value: "v-back",
              icon: "/icons/back-style/v_back.png",
              description:
                "A V-shaped opening at the back, mirroring a V-neck or offering a contrasting detail.",
            },
            {
              label: "U-Back",
              value: "u-back",
              icon: "/icons/back-style/u_back.png",
              description: "A U-shaped, often deep, opening at the back.",
            },
            {
              label: "Keyhole",
              value: "keyhole",
              icon: "/icons/back-style/keyhole_back.png",
              description:
                "A teardrop or keyhole-shaped opening at the back, usually at the nape of the neck.",
            },
          ],
          ambience: [
            {
              label: "Beach",
              value: "beach",
              icon: "/icons/ambience/beach.png",
              description:
                "Visualize your dress flowing in a sunny, breezy beach setting.",
            },
            {
              label: "Office",
              value: "office",
              icon: "/icons/ambience/office.png",
              description:
                "Picture your dress in a modern, professional office environment.",
            },
            {
              label: "Party",
              value: "party",
              icon: "/icons/ambience/party.png",
              description:
                "Imagine your dress shining at a vibrant party or evening event.",
            },
          ],
          color: [
            {
              label: "Red",
              value: "red",
              swatch: "#dc2626",
              description:
                "A bold and passionate red, perfect for making a statement.",
            },
            {
              label: "Black",
              value: "black",
              swatch: "#000000",
              description:
                "Classic, elegant, and versatile. The epitome of chic.",
            },
            {
              label: "Blue",
              value: "blue",
              swatch: "#2563eb",
              description:
                "A cool, serene, and versatile blue. Can range from deep navy to bright royal.",
            },
            {
              label: "Deep Navy Hue",
              value: "midnight blue",
              swatch: "#000035",
              description:
                "A deep navy hue",
            },
            {
              label: "White",
              value: "white",
              swatch: "#ffffff",
              border: true,
              description:
                "Pure, crisp, and timeless. Often chosen for bridal or summer wear.",
            },
            {
              label: "Emerald",
              value: "emerald",
              swatch: "#10B981",
              border: false,
              description: "A rich, luxurious, and jewel-toned green.",
            },
          ],
          fabric: [
            {
              label: "Cotton",
              value: "cotton",
              icon: "/icons/fabric/cotton.png",
              description:
                "A soft, breathable, and comfortable natural fabric, great for everyday wear.",
            },
          ],
        },
      };
    }, []);

  // New Handler
  const handleOptionInteraction = (field, value) => {
    // This map helps us find the full option details (like the description)
    const allOptions = {
      bodice: bodiceOptions,
      neckline: necklineOptions,
      sleeve: genericOptions.sleeve,
      skirt: skirtOptions,
      length: genericOptions.length,
      backstyle: genericOptions.backstyle,
      fabric: genericOptions.fabric,
      color: genericOptions.color,
      ambience: genericOptions.ambience,
    };

    // This map helps us call the correct final selection function
    const selectionHandlers = {
      bodice: handleBodiceSelect,
      neckline: handleNecklineSelect,
      sleeve: handleSleeveSelect,
      skirt: handleSkirtSelect,
      length: handleLengthSelect,
      backstyle: handleBackstyleSelect,
      fabric: handleFabricSelect,
      color: handleColorSelect,
      ambience: handleAmbienceSelect,
    };

    // Find the full option object to show its info
    const fullOption = allOptions[field]?.find((opt) => opt.value === value);
    setHoveredOptionInfo(fullOption || null);

    // --- Core Logic: Decide whether to Preview or Select ---
    if (previewedValues[field] === value) {
      // If tapping the already previewed item, it's a SELECTION
      selectionHandlers[field]?.(value);
      setPreviewedValues((prev) => ({ ...prev, [field]: null })); // Clear preview after selection
      setHoveredOptionInfo(null); // Clear info pane after selection
    } else {
      // Otherwise, it's a PREVIEW
      setPreviewedValues((prev) => ({ ...prev, [field]: value }));
    }
  };
  // NEW: Create a master object of all options to pass down for label lookups
  const allOptionsForDisplay = useMemo(
    () => ({
      bodice: bodiceOptions,
      skirt: skirtOptions,
      neckline: necklineOptions,
      sleeve: genericOptions.sleeve,
      length: genericOptions.length,
      backstyle: genericOptions.backstyle,
      color: genericOptions.color,
      fabric: genericOptions.fabric,
      ambience: genericOptions.ambience,
    }),
    [bodiceOptions, skirtOptions, necklineOptions, genericOptions]
  );
  const isCategoryComplete = useCallback(
    (categoryId) => {
      const categoryConfig = CATEGORIES_CONFIG[categoryId];
      if (!categoryConfig) return false;
      return categoryConfig.fields.every((field) => !!selectedValues[field]);
    },
    [selectedValues]
  );

  useEffect(() => {
    const newCompleted = {};
    CATEGORY_ORDER.forEach((catId) => {
      newCompleted[catId] = isCategoryComplete(catId);
    });
    setCompletedCategories(newCompleted);
  }, [selectedValues, isCategoryComplete]);

  const handleSelectionAndAdvance = (fieldName, value, setterFunction) => {
    setterFunction(value);
    const currentCategoryConfig = CATEGORIES_CONFIG[activeCategoryId];
    if (currentCategoryConfig) {
      const currentFieldIndex = currentCategoryConfig.fields.indexOf(fieldName);
      if (
        currentFieldIndex !== -1 &&
        currentFieldIndex < currentCategoryConfig.fields.length - 1
      ) {
        const nextFieldName =
          currentCategoryConfig.fields[currentFieldIndex + 1];
        const nextFieldRef = optionGroupRefs[nextFieldName];
        if (nextFieldRef && nextFieldRef.current) {
          setTimeout(() => {
            if (nextFieldRef.current) {
              nextFieldRef.current.scrollIntoView({
                behavior: "smooth",
                block: "start",
              });
            }
          }, 200);
        }
      }
    }
  };

  const handleBodiceSelect = (value) => {
    setNeckline("");
    setSkirt("");
    setSleeve("");
    setBackstyle("");
    setLength("");
    setHoveredOptionInfo(null);
    handleSelectionAndAdvance("bodice", value, setBodice);
  };

  const handleSkirtSelect = (value) =>
    handleSelectionAndAdvance("skirt", value, setSkirt);
  const handleNecklineSelect = (value) =>
    handleSelectionAndAdvance("neckline", value, setNeckline);
  const handleSleeveSelect = (value) =>
    handleSelectionAndAdvance("sleeve", value, setSleeve);
  const handleLengthSelect = (value) =>
    handleSelectionAndAdvance("length", value, setLength);
  const handleFabricSelect = (value) =>
    handleSelectionAndAdvance("fabric", value, setFabric);
  const handleColorSelect = (value) =>
    handleSelectionAndAdvance("color", value, setColor);
  const handleBackstyleSelect = (value) =>
    handleSelectionAndAdvance("backstyle", value, setBackstyle);
  const handleAmbienceSelect = (value) =>
    handleSelectionAndAdvance("ambience", value, setAmbience);

  const canGenerate = useMemo(() => {
    if (authError || !isAuthenticated) return false;
    return CATEGORY_ORDER.every((catId) => completedCategories[catId]);
  }, [completedCategories, authError, isAuthenticated]);

  const handleGenerate = useCallback(async () => {
    if (!canGenerate) {
      if (!isAuthenticated && !isAuthLoading) {
        setError("Session not active. Please refresh or try again later.");
      }
      return;
    }
    setLoading(true);
    setError("");
    setGeneratedImage("");
    // setDressAnalysis(""); // <-- DELETE THIS LINE
    try {
      const response = await fetchDressImage(selectedValues);
      setGeneratedImage(response.imageUrl);
      // setDressAnalysis(response.analysis || "Analysis not available."); // <-- DELETE THIS LINE
    } catch (err) {
      setError(
        String(err.message || "An unknown error occurred during generation.")
      );
    } finally {
      setLoading(false);
    }
  }, [selectedValues, canGenerate, isAuthenticated, isAuthLoading]);

  const handleNextCategory = () => {
    const currentCategoryConfig = CATEGORIES_CONFIG[activeCategoryId];
    if (currentCategoryConfig && currentCategoryConfig.next) {
      setActiveCategoryId(currentCategoryConfig.next);
      setHoveredOptionInfo(null);
    }
  };

  const handleCategorySelect = (categoryId) => {
    setActiveCategoryId(categoryId);
    setHoveredOptionInfo(null); // Reset hover info on any category change

    // If the user clicks on the "Shape & Fit" tab, reset all its fields
    if (categoryId === "SHAPE") {
      setBodice("");
      setNeckline("");
      setSleeve("");
      setSkirt("");
      setLength("");
      setBackstyle("");
    }
  };

  const renderCategoryOptions = () => {
    const currentCategoryConfig = CATEGORIES_CONFIG[activeCategoryId];
    if (!currentCategoryConfig) return null;

    const getFilteredOpts = (field, baseOptions) => {
      const result = filterOptions(
        field,
        baseOptions,
        selectedValues,
        compatibilityMap
      );
      return result;
    };

    const commonProps = {
      selectedValues,
      onOptionHover: setHoveredOptionInfo,
      compatibilityMap,
    };
    let optionsToRender;

    switch (activeCategoryId) {
      case "SHAPE":
        optionsToRender = (
          <>
            <div ref={optionGroupRefs.bodice}>
              <IconOptionSelector
                title="Bodice Style"
                options={getFilteredOpts("bodice", bodiceOptions)}
                previewedValue={previewedValues.bodice}
                onOptionClick={(value) =>
                  handleOptionInteraction("bodice", value)
                }
                selectedValue={bodice}
                onSelect={handleBodiceSelect}
                {...commonProps}
              />
            </div>
            <div ref={optionGroupRefs.neckline}>
              <IconOptionSelector
                title="Neckline"
                options={getFilteredOpts("neckline", necklineOptions)}
                selectedValue={neckline}
                previewedValue={previewedValues.neckline}
                onOptionClick={(value) =>
                  handleOptionInteraction("neckline", value)
                }
                onSelect={handleNecklineSelect}
                {...commonProps}
              />
            </div>
            <div ref={optionGroupRefs.sleeve}>
              <IconOptionSelector
                title="Sleeve Style"
                options={getFilteredOpts("sleeve", genericOptions.sleeve)}
                selectedValue={sleeve}
                onSelect={handleSleeveSelect}
                {...commonProps}
              />
            </div>
            <div ref={optionGroupRefs.backstyle}>
              <IconOptionSelector
                title="Back Style"
                options={getFilteredOpts("backstyle", genericOptions.backstyle)}
                selectedValue={backstyle}
                onSelect={handleBackstyleSelect}
                {...commonProps}
              />
            </div>
            <div ref={optionGroupRefs.skirt}>
              <IconOptionSelector
                title="Skirt Style"
                options={getFilteredOpts("skirt", skirtOptions)}
                selectedValue={skirt}
                onSelect={handleSkirtSelect}
                {...commonProps}
              />
            </div>
            <div ref={optionGroupRefs.length}>
              <IconOptionSelector
                title="Dress Length"
                options={getFilteredOpts("length", genericOptions.length)}
                selectedValue={length}
                onSelect={handleLengthSelect}
                {...commonProps}
              />
            </div>
          </>
        );
        break;
      case "MATERIALS":
        optionsToRender = (
          <>
            <div ref={optionGroupRefs.fabric}>
              <IconOptionSelector
                title="Fabric"
                options={getFilteredOpts("fabric", genericOptions.fabric)}
                selectedValue={fabric}
                onSelect={handleFabricSelect}
                itemType="fabric"
                {...commonProps}
              />
            </div>
            <div ref={optionGroupRefs.color}>
              <IconOptionSelector
                title="Color"
                options={getFilteredOpts("color", genericOptions.color)}
                selectedValue={color}
                onSelect={handleColorSelect}
                itemType="color"
                {...commonProps}
              />
            </div>
          </>
        );
        break;
      case "SCENE":
        optionsToRender = (
          <>
            <div ref={optionGroupRefs.ambience}>
              <IconOptionSelector
                title="Ambience"
                options={getFilteredOpts("ambience", genericOptions.ambience)}
                selectedValue={ambience}
                onSelect={handleAmbienceSelect}
                {...commonProps}
              />
            </div>
          </>
        );
        break;
      default:
        optionsToRender = null;
    }
    const categoryActuallyComplete = isCategoryComplete(activeCategoryId);
    return (
      <>
        {optionsToRender}
        {categoryActuallyComplete && currentCategoryConfig.next && (
          <button
            onClick={handleNextCategory}
            className="w-full mt-5 py-3 px-5 text-md font-semibold rounded-lg transition-all duration-300 bg-green-500 text-white hover:bg-green-600 shadow-md hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-green-400 focus:ring-opacity-75"
          >
            Next: {CATEGORIES_CONFIG[currentCategoryConfig.next].title} &rarr;
          </button>
        )}
      </>
    );
  };
  const selectedColorObject = genericOptions.color.find(
    (c) => c.value === color
  );

  if (isAuthLoading) {
    return (
      <div className="w-full min-h-screen flex items-center justify-center">
        <p>Initializing Session...</p>
      </div>
    );
  }
  if (authError && !loading) {
    return (
      <div className="w-full min-h-screen flex items-center justify-center">
        <p>
          Session Error: {authError}{" "}
          <button onClick={reInitiateSession}>Retry</button>
        </p>
      </div>
    );
  }

  // ... (all your imports, state definitions, and handler functions remain the same)

  return (
    <div className="w-full flex flex-col lg:flex-row gap-4 xl:gap-6 p-3 sm:p-4 md:p-6 bg-[#F8F8F8] min-h-screen">
      {/* Left Panel: Options (Column 1) */}
      <div className="w-full lg:w-4/12 bg-[#EDEDED] backdrop-blur-lg rounded-2xl shadow-2xl p-4 sm:p-6 flex flex-col">
        {/* ... All content for the left panel ... */}
        <h1 className="text-2xl sm:text-3xl font-bold text-[#333333] mb-1 text-center tracking-tight">
          Design Your Dress
        </h1>
        <p className="text-center text-[#5C5C5C] text-xs sm:text-sm mb-4">
          Follow the steps to create your unique style.
        </p>

        {/* Category Tabs */}
        {/* Category Tabs */}
        {/*<ProgressBar
          steps={CATEGORY_ORDER.map((id) => CATEGORIES_CONFIG[id])}
          currentStepId={activeCategoryId}
          completedSteps={completedCategories}
        />*/}
        <div className="mb-4 sm:mb-5 flex flex-wrap justify-center gap-1.5 sm:gap-2 border-b border-gray-200 pb-3 sm:pb-4">
          {CATEGORY_ORDER.map((catId) => {
            const category = CATEGORIES_CONFIG[catId];
            const isCompleted = completedCategories[catId];
            const isActive = activeCategoryId === catId;

            const showShapeHighlight = catId === "SHAPE" && isActive;
            // --- The button's content, defined once to be reused ---
            const buttonContent = (
              <>
                <span className="mr-1.5 sm:mr-2 text-sm sm:text-base">
                  {category.icon}
                </span>
                {category.title}
                {isCompleted && !isActive && (
                  <svg
                    className="w-3.5 h-3.5 sm:w-4 sm:h-4 ml-1.5 text-green-500"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                )}
              </>
            );

            // --- The button's classes, defined once to be reused ---
            const buttonClasses = `flex items-center px-2.5 py-1.5 sm:px-3 sm:py-2 text-xs sm:text-sm font-medium rounded-lg transition-all duration-200 whitespace-nowrap focus:outline-none focus:ring-2 focus:ring-opacity-50
              ${
                isActive
                  ? "bg-[#005C8C] text-black shadow-lg focus:ring-[#005C8C]" // Active: Deep Ocean Blue
                  : isCompleted && !showShapeHighlight
                  ? "bg-[#E6F3F5] text-[#005C8C] hover:bg-[#D9EBF0] focus:ring-[#005C8C]" // Completed: Light blue tint with teal text
                  : "bg-[#F3F3F3] text-[#5C5C5C] hover:bg-[#EBEBEB] focus:ring-[#B0B0B0]" // Inactive: Very light grey with medium charcoal text
              }
              ${showShapeHighlight ? "pulse-on-complete" : ""}
            `;

            return showShapeHighlight ? (
              <Popover className="relative">
                {({ open }) => (
                  <>
                    {/* The trigger button NO LONGER has the reset onClick.
                        Its only job is to open the popover.
                      */}
                    <button
                      title="Start a new design"
                      className={buttonClasses}
                    >
                      {buttonContent}
                    </button>

                    {/* We conditionally render the panel based on the 'open' state */}
                    {open && (
                      <div className="absolute left-1/2 top-full z-50 mt-2 w-56 -translate-x-1/2 transform px-4 sm:px-0">
                        <div className="overflow-hidden rounded-lg shadow-lg ring-1 ring-black ring-opacity-5">
                          <div className="bg-white p-4">
                            <p className="text-sm font-medium text-gray-900">
                              Start a New Design?
                            </p>
                            <p className="mt-1 text-sm text-gray-500">
                              This will clear your 'Shape & Fit' selections.
                            </p>
                            <div className="mt-4">
                              {/* The reset action has been MOVED to this new button
                                  inside the popover panel.
                                */}
                              <button
                                type="button"
                                onClick={() =>
                                  handleCategorySelect(category.id)
                                }
                                className="w-full rounded-md bg-[#005C8C] px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-[#004A70] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#005C8C]"
                              >
                                Yes, Restart
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                )}
              </Popover>
            ) : (
              // This is the normal button for all other states
              <button
                key={category.id}
                onClick={() => handleCategorySelect(category.id)}
                title={category.title}
                className={buttonClasses}
              >
                {buttonContent}
              </button>
            );
          })}
        </div>

        <InfoPane info={hoveredOptionInfo} />

        <div className="space-y-4 sm:space-y-5 overflow-y-auto flex-grow px-1 sm:px-2 custom-scrollbar min-h-[250px] sm:min-h-[300px]">
          {renderCategoryOptions()}
        </div>

        <button
          onClick={handleGenerate}
          disabled={!canGenerate || loading || !!authError || !isAuthenticated}
          title={
            !canGenerate
              ? "Please complete all sections."
              : "Generate your dress"
          }
          className={`w-full mt-4 sm:mt-5 py-3 sm:py-3.5 px-6 text-md sm:text-lg font-semibold rounded-lg transition-all duration-300 transform hover:scale-[1.02] focus:outline-none focus:ring-4
          ${
            canGenerate && !loading && !authError && isAuthenticated
              ? "bg-[#005C8C] text-white shadow-md hover:bg-[#004A70] focus:ring-[#005C8C]" // Solid Deep Ocean Blue
              : "bg-[#B0B0B0] text-white cursor-not-allowed" // Disabled: Medium Grey, white text for contrast
          }`}
        >
          {loading ? "Generating..." : "✨ Generate My Dress ✨"}
        </button>
        {error && !authError && (
          <p className="text-red-500 mt-2 sm:mt-3 text-center text-xs sm:text-sm">
            {error}
          </p>
        )}
      </div>

      {/* Center Panel: Image Preview (Column 2) - WIDTH ADJUSTED */}
      <div className="w-full lg:w-6/12 flex-grow flex items-center justify-center p-1 sm:p-2 md:p-0">
        <DressPreviewCanvas
          loading={loading && !authError}
          error={error && !authError ? error : null}
          generatedImage={generatedImage}
          selectedColorValue={selectedColorObject?.swatch}
          handleAddToCart={handleFinalAddToCart}
        />
      </div>

      {/* --- Right Panel: Specifications --- */}
      <div className="w-full lg:w-3/12">
        {bodice && !loading && !!generatedImage && (
          <DesignSpecifications
            specs={selectedValues}
            measurements={measurements}
            options={allOptionsForDisplay}
            dynamicDressName={dynamicDressName}
            onOrderNow={() => setIsSizingModalOpen(true)}
            onFinalAddToCart={handleFinalAddToCart}
            loading={loading} // <-- PASS THE LOADING STATE AS A PROP
            generatedImage={generatedImage}
          />
        )}
      </div>

      {/* --- The Modal --- */}
      <MadeToMeasureModal
        isOpen={isSizingModalOpen}
        onClose={() => setIsSizingModalOpen(false)}
        onConfirm={handleMeasurementsConfirm} // Use the new confirm handler
      />
    </div>
  );
}

export default CustomizationPanel;
